"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = void 0;
var container = {
  width: {
    default: '100%',
    fluid: {
      sm: '540px',
      md: '720px',
      lg: '960px',
      xl: '1140px'
    }
  },
  fontSize: {
    default: '1rem'
  },
  fontWeight: {
    default: '400'
  },
  fontFamily: {
    default: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
  }
};
exports.container = container;


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-config/lib/theme/container.js
// module id = 1161
// module chunks = 0